import React from 'react'
import '../CSS/style.css'
import '../CSS/responsive.css'
import { useState } from 'react'
import {  ref, set } from "firebase/database";
import { Realtime_db }  from "./firebase_config_programs"


  function writeUserData( name, email, message) {
    
    const date = new Date();
    
    const userId = Math.floor(Math.random()*10000 -1)+ "" +date.getFullYear() +  date.getMilliseconds()  ;
    set(ref(Realtime_db , 'FeedBacks/' + userId),  {
      username: name,
      email: email,
      message : message,
      timeStamp : date.getFullYear() +"/"+ (date.getMonth()+1) +"/"+ date.getDate()
    });
    
  }

  function validate(name , email , message){
    if(name === "" || email === "" || message === "")
    {
       return 0; 
    }
    return 1;
  }

export default function ContactUs() {

    // document.title = "Contact Us - UnlockCode"

    const [message, setmessage] = useState("");
    const [name, setName] = useState("");
    const [Email, setEmail] = useState("");
    const handleOnChangeMsg = (event) =>{
        setmessage(event.target.value);
    }
    const handleOnChangeName = (event) =>{
        setName(event.target.value);
    }
    const handleOnChangeEmail = (event) =>{
        setEmail(event.target.value);
    }

    const onClickSubmit = () =>{
        if(validate(name , Email , message)){
        writeUserData(name , Email , message);
        setName("");
        setEmail("");
        setmessage("");
        alert("FeedBack Received.")
        }
        else{
            alert("Please Try With Proper Inputs.")
        }
    }

  

      
  return (
    <>
        <div className="container fd-col m-auto">
            <div className="p-heading">Contact Us</div>
            <form className='container fd-col'>

                <label htmlFor="name">Name : </label>
                <input type="text" name="name" id="name" placeholder='John Doe' value={name} onChange={handleOnChangeName}/>
                <label htmlFor="email">E-mail : </label>
                <input type="email" name="email" id="email" placeholder='johndoe@example.com' value={Email} onChange={handleOnChangeEmail}/>
                <label htmlFor="message">Message : </label>
                <textarea name="message" id="message" cols="30" rows="10" placeholder='Enter your message / suggestions / feedback here' onChange={handleOnChangeMsg} value={message}></textarea>
            </form>
                <button className='submitbtn' onClick={onClickSubmit}>Submit</button>
        </div>
    </>
  )
}
